var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-container"},[_c('TopBar',{staticClass:"fixed-header"}),_c('div',{staticClass:"main-content",attrs:{"id":"app"}},[_c('router-view')],1),_c('Footer',{staticClass:"fixed-footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }